import fs from 'node:fs'
import path from 'node:path'
import type { LockfileGuardStatus, LockfileRefresher } from '@cli-types/next-adapter/init.js'

export async function guardPnpmLockfile(
  cwd: string,
  restores: Array<() => void>,
  refreshLockfile: LockfileRefresher
): Promise<LockfileGuardStatus> {
  const lockfilePath = path.join(cwd, 'pnpm-lock.yaml')
  if (!fs.existsSync(lockfilePath)) return 'not-needed'

  const original = fs.readFileSync(lockfilePath, 'utf-8')
  restores.push(() => fs.writeFileSync(lockfilePath, original, 'utf-8'))
  return (await refreshLockfile(cwd)) ? 'updated' : 'failed'
}
